import axios from 'axios'
import {message} from 'ant-design-vue'
import {jump} from './jump'
import {util} from './index'
import writeSentry from './writeSentry'

// axios.defaults.withCredentials=true;//让ajax携带cookie
const $ajax= axios.create({
    withCredentials:true
});
$ajax.interceptors.request.use(config=> {
    // Do something before request is sent
    return config;
  }, error=> {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
$ajax.interceptors.response.use(response =>{
  // Do something with response data
  const { data } = response
  if (data) {
    const { code, msg } = data
    if (code * 1 !== 1) {
      if (code * 1 === 3 || code * 1 === 4 || code * 1 === 2007001) {
        util.clearCookies()
        jump.login()
        // 增加莫名登出记录日志
        message.error(msg, 3, () => {
          console.log(`拦截跳转登录`)
          console.log(`请求:`, response.config)
          console.log(`instance:`, response)
        })
        writeSentry('未登陆', response.config.url, response)
      }
    }
  }
    const res = response && response.data ? response.data : response;
    if (!res) {
      writeSentry('返回结果为空', response.config.url, response)
    }
    return res || {}
  }, error => {
    const config = error.config || {}
    writeSentry(error, config.url, error.response)
    message.error(error.toString(), 3, () => {
      console.error(error.config)
    });
    return null;
  });

  const ajax= axios.create();

  ajax.interceptors.response.use(response =>{
    const { data } = response
    if (data) {
      const { code } = data
      if (code * 1 !== 1) {
        if (code * 1 === 3 || code * 1 === 4) {
          util.clearCookies()
        }
      }
    }
    const res = response && response.data ? response.data : response;
    if (!res) {
      writeSentry('返回结果为空', response.config.url, response)
    }
    return res||{}
  }, error => {
    // debugger;
    const config = error.config || {}
    writeSentry(error, config.url, error.response)
    message.error(error.toString());
    return null;
  });

export const $http = $ajax;//拦截款1 :拦截登录
export const http = ajax;//拦截款2  :不拦截登录

